module.exports = __webpack_public_path__ + "static/media/ic_order_taker_selected.e5441eb8.png";